import React from "react";

const About = () => {
  return (
    <>
      <div className="tf-page-title style-2">
        <div className="container-full">
          <div className="heading text-center">About Us </div>
        </div>
      </div>
      <section className="flat-spacing-25">
        <div className="container">
          <div className="tf-main-area-page">
            <p>
              <p>
                "Lyx was born from a passion for redefining luxury fashion. with
                a commitment to quality and a dedication to bringing the essence
                of luxury to everyday wear."
              </p>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
